import lang from "@/views/modules/ApplicationBudgets/language/en";
import breadcrumbs from "@/views/modules/ApplicationBudgets/MenuList.vue";
import Datepicker from 'vuejs-datepicker';
import loader from "@/views/shared/loading/Loading.vue";

export default {
    name: "list-applicationbudgets",
   
    components: {
        breadcrumbs,
        Datepicker,
        loader,
    },
    data() {
        return {
            page: 1,
            search: '',
            selectedOption: '',
            sort: {
                order: 'desc',
                column: 'date_entered',
                relRef: '',
            },
            perPage: 10,
            loading: true,
            productList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang:[],
            counter:0,
            table_head: [
                {
                    label: lang.LBL_BT_NAME,
                    isSort: true,
                    field_name: 'name'
                },
                /*{
                    label: lang.LBL_CR_MULTIPIER,
                    isSort: true,
                    field_name: 'currency_multiplier'
                },*/
                {
                    label: lang.LBL_APP_TITLE,
                    isSort: true,
                    relRef:'applicationbudgets_applications',
                    field_name: 'application_title'
                },
                {
                    label: lang.LBL_OPPORT_NAME,
                    isSort: true,
                    relRef:'applicationbudgets_opportunitys',
                    field_name: 'opportunity_title'
                },
             /*   {
                    label: lang.LBL_APPLICATION_BY,
                    isSort: true,
                    relRef:'applicationbudgets_applications',
                    field_name: 'created_by'
                }, */
                {
                    label: lang.LBL_PI_NAME,
                    isSort: true,
                    relRef:'',
                    field_name: 'created_by_name'
                },
                /*{
                    label: lang.LBL_OPPORTUNITY_BY,
                    isSort: true,
                    relRef:'applicationbudgets_opportunitys',
                    field_name: 'created_by'
                },
                 {
                    label: lang.LBL_STRATEGIC_PRIORITY,
                    isSort: true,
                    field_name: 'strategic_priority'
                }, */
                {
                    label: lang.LBL_APP_BUDGET_STATUS,
                    isSort: true,
                    field_name: 'app_budget_status'
                },
                {
                    label: lang.LBL_MARK_APPROVED,
                    isSort: true,
                    field_name: 'app_budget_status'
                }
            ]
        }
    },
    mounted() {        
        this.lang = lang;
        /* let filtersToStore = {app_budget_status:{
            key:'app_budget_status',
            value:'Pending'
        }};
        localStorage.setItem('filters', JSON.stringify(filtersToStore)); */ /////commented by abhay issue raised on main on 01-05-2026
        this.getProducts();
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        sortBy(field, relRef) {
            if (this.sort.column === field) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.order = 'asc';
            }
            this.sort.column = field;
            this.sort.relRef = relRef;
            this.getProducts()
        },
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getProducts();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getProducts();
        },
        getProducts(search = '') {
            const self = this;
            self.loading = true;

            let storedFilters = localStorage.getItem('filters');
          
            if (storedFilters !== '') {
                self.search=storedFilters;
            }
            
            if (search != '') {
                self.search = search;
            }
            window.currentAction = 'list';
                axios.get('api/modules/applicationbudgets', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.productList = response.data.items;
               
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getProducts();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },

        count_index(counter){
            const self = this;

            self.counter = counter+1;

            return self.counter;
        },
        exportData() {
            const selectedValues = []
            this.records = {
                module: 'ApplicationBudgets',
                ids: selectedValues,
                callingFrom: 'export',
                all: this.selectedOption,
                search: this.search,
            }

            axios.post('api/export', this.records).then(function (response) {
                var link = document.createElement('a');
                link.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data);
                link.download = 'data.csv';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(function () {
                self.loading = false;
            });
        },
        markStatus(rowid, status, i){
            const self = this;
            axios.post('api/modules/approvebudget', {'app_temp_id':rowid, 'app_budget_status':status}).then(function (response) {
               if(response.data.message){
                    self.productList[i].app_budget_status = status;
               }
            })
        }
    
    }
}
